/**
 * SpotlightRing — a glowing purple ring around a measured target rect (design variant 1a: interactive,
 * so NO dimming mask; real taps pass through, `pointerEvents="none"`). Rendered static (no pulse) by
 * request — the constant ring is calmer and reads as "tap here" without the breathing motion.
 * `reduceMotion` is accepted for API compatibility but the ring no longer animates in either mode.
 * See specs/first-challenge-onboarding/spec.md.
 */

import { View, StyleSheet } from 'react-native';
import { COACH_C, COACH_TEST_IDS } from '../CoachCard/CoachCard.constants';

export interface SpotlightRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

interface SpotlightRingProps {
  /** Target rect in overlay coordinates (padding already applied by the caller). Null hides the ring. */
  rect: SpotlightRect | null;
  /** Accepted for API compatibility; the ring is static regardless. */
  reduceMotion?: boolean;
  testID?: string;
}

export function SpotlightRing({ rect, testID }: SpotlightRingProps) {
  if (!rect) return null;

  return (
    <View
      testID={testID ?? COACH_TEST_IDS.RING}
      pointerEvents="none"
      style={[
        styles.ring,
        { left: rect.x, top: rect.y, width: rect.width, height: rect.height },
      ]}
    />
  );
}

const styles = StyleSheet.create({
  ring: {
    position: 'absolute',
    borderRadius: 14,
    borderWidth: 2.5,
    borderColor: COACH_C.ringPurple,
    // Purple glow (RN-web → box-shadow; native → shadow* + elevation)
    shadowColor: COACH_C.ringPurple,
    shadowOpacity: 0.6,
    shadowRadius: 16,
    shadowOffset: { width: 0, height: 0 },
    elevation: 12,
    zIndex: 40,
  },
});
